import { render, staticRenderFns } from "./UserRightSelector.vue?vue&type=template&id=0a2a23ea&"
import script from "./UserRightSelector.vue?vue&type=script&lang=js&"
export * from "./UserRightSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports